module.exports = __webpack_public_path__ + "assets/d4f28f9735fcdc91e0d68edb2f5dbe83.png";